export default defineNuxtPlugin(nuxtApp => {
  const {
    public: { recaptchaKey },
  } = useRuntimeConfig();

  // Если ключ reCAPTCHA отсутствует или пуст, плагин ничего не делает
  if (!recaptchaKey) {
    console.warn('reCAPTCHA: ключ не указан. Функциональность отключена.');
    return {
      provide: {
        recaptcha: {
          getToken: async () => null,
          preload: async () => false,
        },
      },
    };
  }

  const siteKey = recaptchaKey as string;

  // Инициализация состояния
  const isRecaptchaLoaded = ref(false);
  const isRecaptchaLoading = ref(false);

  // Функция загрузки скрипта reCAPTCHA
  const loadRecaptchaScript = () => {
    return new Promise<void>((resolve, reject) => {
      if (isRecaptchaLoaded.value) {
        resolve();
        return;
      }

      if (isRecaptchaLoading.value) {
        const checkIfLoaded = setInterval(() => {
          if (isRecaptchaLoaded.value) {
            clearInterval(checkIfLoaded);
            resolve();
          }
        }, 100);
        return;
      }

      isRecaptchaLoading.value = true;

      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/enterprise.js?render=${siteKey}`;
      script.async = true;
      script.defer = true;

      script.onload = () => {
        if (window.grecaptcha) {
          isRecaptchaLoaded.value = true;
          isRecaptchaLoading.value = false;
          resolve();
        } else {
          const checkGrecaptcha = setInterval(() => {
            if (window.grecaptcha) {
              clearInterval(checkGrecaptcha);
              isRecaptchaLoaded.value = true;
              isRecaptchaLoading.value = false;
              resolve();
            }
          }, 100);
        }
      };

      script.onerror = error => {
        isRecaptchaLoading.value = false;
        reject(error);
      };

      document.head.appendChild(script);
    });
  };

  const preloadRecaptchaScript = async () => {
    try {
      await loadRecaptchaScript();
      return true;
    } catch (error) {
      console.error('Error preload reCAPTCHA:', error);
      return false;
    }
  };

  const getRecaptchaToken = async (action = 'submit') => {
    try {
      await loadRecaptchaScript();
      return await window.grecaptcha.enterprise.execute(siteKey, { action: 'frontend_form' });
    } catch (error) {
      console.error('Error: getRecaptchaToken reCAPTCHA:', error);
      return null;
    }
  };

  return {
    provide: {
      recaptcha: {
        getToken: getRecaptchaToken,
        preload: preloadRecaptchaScript,
      },
    },
  };
});
